import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { automationReceivedRuleList } from "../../../../../../../services/ticketAutomationReceivedRule.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleAllowedAction.";

export const ExamsReceivedRule = () => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(automationReceivedRuleList);

  const [optionsExamsReceivedRule, setExamsReceivedRule] = useState<
    ISelectType[]
  >([]);

  const fetchExamsReceivedRule = useCallback(async () => {
    const { data, success } = await sendRequest({ ticketAutomationCode: 21 });
    if (data && success) {
      setExamsReceivedRule(
        data.map((d) => ({
          id: d.id,
          name: d.name,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchExamsReceivedRule();
  }, [fetchExamsReceivedRule]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        fullWidth
        options={optionsExamsReceivedRule}
        name="examTicketAutomationReceivedRule"
        label={t(translationPath + "exam_received_rule")}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
};
